module.exports = __webpack_public_path__ + "static/media/menu-icon.a84ccee3.svg";